// @ts-nocheck
import { StyledClickable } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { css } from "styled-components";

// Foundation --->
import { resolveColor } from "@insite/mobius/utilities";
import { TypographyBorderOptions } from "@store/MobiusOverrides/Typography/Typography";
import breakpointValues, { BreakpointValue } from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { Amount, pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
// <--- Foundation

export const inlineSeparatorStyles = (options?: {
    color?: string;
    height?: string;
    side?: "left" | "right";
    spacing?: string;
    spacingType?: "margin" | "padding";
    width?: string;
}) => {
    const {
        color = "common.border",
        height = "1em",
        side = "right",
        spacing = "1em",
        spacingType = "margin",
        width = "1px",
    } = options || {};

    const sideSelector = side === "right" ? "&:last-child" : "&:first-child";

    return css`
        position: relative;
        ${spacingType}-${side}: calc(${spacing} + ${width});

        &::after {
            content: "";
            position: absolute;
            ${side}: ${spacingType === "padding" ? `calc(${spacing} / 2)` : `calc((-${spacing} / 2) - ${width})`};
            height: ${height};
            width: ${width};
            background-color: ${getColor(color)};
            top: 50%;
            transform: translateY(-50%);
            pointer-events: none;
        }

        ${sideSelector} {
            ${spacingType}-${side}: 0;

            &::after {
                display: none;
            }
        }
    `;
};

export const lineEllipsisStyles = (lineClamp: number) => {
    return css`
        /* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: ${lineClamp};
        -webkit-box-orient: vertical;
        /* stylelint-enable value-no-vendor-prefix, property-no-vendor-prefix */
    `;
};

export const loadingDotsStyles = () => {
    return css`
        display: inline-block;
        text-align: left;
        font-weight: ${x => x.theme.design.typography.weight.bold};
        min-width: ${pxToRem(25)};

        &::after {
            overflow: hidden;
            display: inline-block;
            vertical-align: bottom;
            animation: loadingDots steps(4, end) 900ms infinite 1s;
            content: "\\2026";
            width: 0;
        }
    `;
};

export const loadingDotsKeyFrames = () => {
    return css`
        @keyframes loadingDots {
            to {
                width: 1.25em;
            }
        }
    `;
};

export const typographyInvertColorStyles = (color = "invert", hoverColor = "invert.dark") => {
    return css`
        color: ${getColor(color)};

        ${TypographyStyle} {
            color: inherit;
        }

        ${StyledClickable} {
            ${linkStyles("inherit", hoverColor, true, true)}
        }
    `;
};

// Foundation --->
export const loadingDotsAnimation = () => {
    return css`
        display: inline-block;
        text-align: left;
        font-weight: ${({ theme }) => theme.design.typography.weight.bold};
        min-width: ${pxToRem(25)};

        &::after {
            overflow: hidden;
            display: inline-block;
            vertical-align: bottom;
            animation: ellipsis steps(4, end) 900ms infinite 1s;
            content: "\\2026";
            width: 0;
        }

        @keyframes ellipsis {
            to {
                width: 1.25em;
            }
        }
    `;
};

export const labelSeparationStyles = (spacing = 10) => {
    return css`
        position: relative;
        padding-right: ${spacing}px;
        margin-right: ${spacing}px;
        margin-bottom: 0;

        &::after {
            content: "";
            position: absolute;
            top: 50%;
            right: 0;
            width: ${pxToRem(1)};
            height: 0.8em;
            background-color: ${getColor("common.borderDark")};
            transform: translateY(-50%);
        }

        &:last-child::after {
            display: none;
        }
    `;
};

export const titleBorderStyles = ({
    align = "flex-start",
    color = "secondary",
    side = "top",
}: TypographyBorderOptions) => {
    return css`
        display: flex;
        flex-direction: ${side === "top" ? "column-reverse" : "column"};
        align-items: ${align};

        &::after {
            content: "";
            position: relative;
            ${side === "top"
                ? `
            top: ${pxToRem(-16)};
        `
                : `
            bottom: ${pxToRem(-8)};
        `}
            display: block;
            width: ${pxToRem(35)};
            height: ${pxToRem(3)};
            background-color: ${({ theme }) => resolveColor(color || "secondary", theme)};
        }
    `;
};
export const typographyTitleStyles = (fontSizes?: BreakpointValue<Amount>[]) => {
    return css`
        ${breakpointValues(fontSizes, "font-size")}
        ${({ theme }) => `
            font-family: ${theme.design.typography.fontFamily.title};
            font-weight: ${theme.design.typography.weight.bold};
        `}
    `;
};
export const handleTextAlignment = (alignment: "flex-start" | "center" | "flex-end") => {
    switch (alignment) {
        case "flex-start":
            return "left";
        case "center":
            return "center";
        case "flex-end":
            return "right";
        default:
            return "left";
    }
};
// <--- Foundation
